jQuery(document).ready(function($) {
  displaySingleCurrentLocation();
  $('button[data-set-location]').click(function() {
    // var distance = $(this).attr('data-distance');
    var location_title = $(this).attr('data-title');
    var location_id = $(this).attr('data-location-id');
    var order_url = $(this).attr('data-order-url');
    var permalink = $(this).attr('data-permalink');

    setAsStore(location_id, location_title, order_url, permalink);
  });
});

function displaySingleCurrentLocation() {
  var $ = jQuery;
  var locationID = localStorage.getItem('charleys_visitor_nearest_location_id');

  $('.set-location-button').each(function() {
    $(this).removeClass('current-location');
  });

  if(locationID) {
    $('.set-location-button[data-location-id="'+locationID+'"]').addClass('current-location');
  }
}
